import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MaintenanceService } from 'src/app/core/maintenance.service';
import { LayoutService } from '../../layout/layout.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  isDarkMode = false;
  private configSubscription: Subscription;

  constructor(
    public maintenanceService: MaintenanceService,
    private layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.isDarkMode =
      this.layoutService.config.colorScheme === 'dark';

    this.configSubscription =
      this.layoutService.configUpdate$.subscribe({
        next: (config) => {
          this.isDarkMode = config.colorScheme === 'dark';
        },
      });
  }

  ngOnDestroy(): void {
    if (this.configSubscription) {
      this.configSubscription.unsubscribe();
    }
  }
}
